import React from 'react';
import NewOpportunity from './NewOpportunity';

/**
 * Edit Opportunity page. Opportunity data should be obtained from the server before page load.
 * @param orgID
 * @param oppID
 * @return {JSX.Element}
 * @constructor
 */

const EditOpportunity = ({ orgID, oppID }) => {
	return (
		<div>
			<NewOpportunity orgID={orgID} oppID={oppID} />
		</div>
	);
};

export default EditOpportunity;
